import React, { FC } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import GlobalStyles from '../styles/GlobalStyles';

interface Props {
    isOpen: boolean
}

const ScreenLoader: FC<Props> = p => {

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            backdrop: {
                zIndex: theme.zIndex.drawer + 1,
                color: GlobalStyles.secondaryColor,
            },
        }),
    );

    const classes = useStyles();
    return (
        <>
            <Backdrop className={classes.backdrop} open={p.isOpen}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default ScreenLoader;
